import { ADD_BILL_TERM, DELETE_BILL_TERM, GET_BILL_TERM, UPDATE_BILL_TERM,  GET_ONE_BILL_TERM} from "../types";
  
  // const initialState = { list: [], single: null, totalCount: 0 };

  const initialState = {
    list: [],
    pagination:{
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
    },
    single: null
  };
  
  const reducer = (state = initialState, action) => {
    const { type, payload, totalCount } = action;
  
    switch (type) {
      case GET_BILL_TERM:
        return { ...state, list: payload.data, totalCount: totalCount , pagination: payload.pagination };
  
      case UPDATE_BILL_TERM:
        return {
          ...state,
          list: state.list.map((item) =>
            item.id === payload.id ? payload : item
          ),
        };
  
      case ADD_BILL_TERM:
        return {
          ...state,
          list: [payload, ...state.list],
        };
  
      case DELETE_BILL_TERM:
        return {
          ...state,
          list: state.list.filter((item) => item.id !== payload.id),
        };

      case GET_ONE_BILL_TERM:
        return { ...state, single: payload };
  
      default:
        return state;
    }
  };
  
  export default reducer;
  